import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const ConfirmNew24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M19.4605 5.25982C19.8108 4.91521 20.3809 4.91314 20.7339 5.25518C21.0868 5.59724 21.089 6.1539 20.7387 6.49852L8.71775 18.324C8.45885 18.5799 8.14069 18.7728 7.79086 18.8855C7.44069 18.9984 7.06808 19.0283 6.70371 18.973C6.33936 18.9176 5.99368 18.7785 5.69518 18.5671C5.39701 18.3559 5.15443 18.0787 4.9874 17.7581M4.9874 17.7581L3.09892 14.152C2.87252 13.7196 3.04792 13.19 3.49068 12.9689C3.93343 12.7479 4.47588 12.9192 4.70228 13.3515L6.59211 16.9602C6.62989 17.0328 6.68497 17.0959 6.75248 17.1437C6.81999 17.1916 6.89818 17.223 6.98059 17.2355C7.063 17.2481 7.14728 17.2413 7.22648 17.2158C7.30569 17.1902 7.37754 17.1467 7.43612 17.0888L19.4605 5.25982"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
